const mainSearchForm = {
  flights: "항공편", // translated 
  tours: "투어", // translated 
  hotel: "호텔", // translated 
  hotels: "호텔", // translated 
  services: "서비스", // translated 
  search: "찾다", // translated 
  destination: "목적지", // translated 
  includedServices: "포함된 서비스", // translated 
  packageDuration: "패키지 기간", // translated 
  checkInOut: "체크인/체크아웃", // translated 
  guests: "손님", // translated 
  adults: "성인", // translated 
  children: "어린이들", // translated 
  child: "어린이", // translated 
  age: "나이", // translated 
  yearsOld: "세", // translated 
  rooms: "객실", // translated 
  close: "닫다", // translated 
  searchType: "검색 유형", // translated 
  accommodation: "숙소", // translated 
  transfers: "이적", // translated 
  toursExperiences: "투어/체험", // translated 
  nights: "밤들", // translated 
  days: "날", // translated 
  packageType: "패키지 유형", // translated 
  tourType: "투어 유형", // translated 
  packages: "패키지", // translated 
  cars: "자동차", // translated 
  cruises: "크루즈", // translated 
  infantsInSeat: "유아용 좌석", // translated 
  infantsOnLap: "무릎에 앉은 아기", // translated 
  airport: "공항", // translated 
  passengers: "승객들", // translated 
  departureReturn: "출발일 및 귀국일", // translated 
  origin: "기원", // translated 
  roundTrip: "왕복", // translated 
  isRoundTrip: "왕복입니다", // translated 
  dream_packages: "꿈의 패키지", // translated 
  partying: "파티", // translated 
  thingsToDo: "할 일", // translated 
};


export default mainSearchForm;
